export default "__VITE_ASSET__BzFZn1S5__"